<template>
  <section class="mt-2">
    <div class="normalMultiDatesCalendar datepicker-here"></div>
  </section>
</template>

<script>
  import 'air-datepicker'
  import 'air-datepicker/dist/js/i18n/datepicker.en.js'
  import i18n from '../../helpers/i18nHelpers'
  import moment from 'moment-timezone'
  import serviceHelpers from '../../helpers/serviceHelpers'

  export default {
    props: {
      maxNum: Number,
      serviceId: Number,
      provinceId: Number,
      sameDayBookingConfig: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        datePicker: null,
        language: 'en'
      }
    },
    watch: {
      provinceId () {
        console.log('check province id', this.provinceId)
        this.clearSelectedDates()
        this.initCalendar()
      }
    },
    methods: {
      clearSelectedDates () {
        this.datePicker.data('datepicker').clear()
      },
      initCalendar () {
        const currentHour = moment().hour()
        let sameDayBookingConfig = serviceHelpers.formatSameDayData(this.sameDayBookingConfig)
        if (this.serviceId && sameDayBookingConfig.services) {
          let hasSameDayService = sameDayBookingConfig.services.some(service => service.service_id === this.serviceId)
          if (hasSameDayService) {
            sameDayBookingConfig = serviceHelpers.getSameDayService(sameDayBookingConfig, this.serviceId, this.provinceId)
          }
        }
        const canBookToHour = sameDayBookingConfig.can_book_to_hour
        let numDay = 1
        if (!sameDayBookingConfig.can_book_same_day) {
          numDay = (sameDayBookingConfig.num_next_day) ? sameDayBookingConfig.num_next_day : 1
        }
        if (currentHour >= canBookToHour) {
          numDay += 1
        }
        const minDate = moment().add(numDay, 'days')
        this.language = i18n.locale

        this.$nextTick(() => {
          window.$.fn.datepicker.language['th'] = {
            days: [i18n.t('message.calendar.week.01'), i18n.t('message.calendar.week.02'), i18n.t('message.calendar.week.03'), i18n.t('message.calendar.week.04'), i18n.t('message.calendar.week.05'), i18n.t('message.calendar.week.06'), i18n.t('message.calendar.week.07')],
            daysShort: [i18n.t('message.calendar.week_short.01'), i18n.t('message.calendar.week_short.02'), i18n.t('message.calendar.week_short.03'), i18n.t('message.calendar.week_short.04'), i18n.t('message.calendar.week_short.05'), i18n.t('message.calendar.week_short.06'), i18n.t('message.calendar.week_short.07')],
            daysMin: [i18n.t('message.calendar.week_short.01'), i18n.t('message.calendar.week_short.02'), i18n.t('message.calendar.week_short.03'), i18n.t('message.calendar.week_short.04'), i18n.t('message.calendar.week_short.05'), i18n.t('message.calendar.week_short.06'), i18n.t('message.calendar.week_short.07')],
            months: [i18n.t('message.calendar.month.01'), i18n.t('message.calendar.month.02'), i18n.t('message.calendar.month.03'), i18n.t('message.calendar.month.04'), i18n.t('message.calendar.month.05'), i18n.t('message.calendar.month.06'), i18n.t('message.calendar.month.07'), i18n.t('message.calendar.month.08'), i18n.t('message.calendar.month.09'), i18n.t('message.calendar.month.10'), i18n.t('message.calendar.month.11'), i18n.t('message.calendar.month.12')],
            monthsShort: [i18n.t('message.calendar.month_short.01'), i18n.t('message.calendar.month_short.02'), i18n.t('message.calendar.month_short.03'), i18n.t('message.calendar.month_short.04'), i18n.t('message.calendar.month_short.05'), i18n.t('message.calendar.month_short.06'), i18n.t('message.calendar.month_short.07'), i18n.t('message.calendar.month_short.08'), i18n.t('message.calendar.month_short.09'), i18n.t('message.calendar.month_short.10'), i18n.t('message.calendar.month_short.11'), i18n.t('message.calendar.month_short.12')],
            today: i18n.t('message.calendar.today'),
            clear: 'Clear',
            dateFormat: 'dd/mm/yyyy',
            timeFormat: 'hh:ii aa',
            firstDay: 0
          }

          this.datePicker = window.$('.normalMultiDatesCalendar').datepicker({
            language: this.language,
            minDate: minDate.toDate(),
            multipleDates: 50,
            multipleDatesSeparator: ', ',
            onSelect: (selectedDate, datePicker) => {
              this.$emit('selectDate', selectedDate, datePicker)
            }
          })
        })
      }
    },
    mounted () {
      this.initCalendar()
    }
  }
</script>


<style scoped>
  @import "~air-datepicker/dist/css/datepicker.min.css";
</style>



// WEBPACK FOOTER //
// src/components/booking/MultiDatesCalendar.vue